import { Button } from '@homeexchange/design';
import React from 'react';
import i18n from '../../i18n';
var HomeFavoriteButton = function (_a) {
    var _b = _a.isFavorite, isFavorite = _b === void 0 ? false : _b, onClick = _a.onClick;
    return (React.createElement(Button, { hierarchy: "secondary", onClick: onClick, size: "large", isFullWidth: true, icon: isFavorite ? 'HeartFilled' : 'HeartOutline' }, i18n.t("home:".concat(isFavorite ? 'remove_favorites' : 'add_favorites'))));
};
export default HomeFavoriteButton;
